// CartButton.js
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from 'api';
import { formatPrice, debug } from 'utils';

import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useNavigate } from "react-router-dom";
import useCheckout from "components/orders/hooks/useCheckout";
import OrderPaymentModal from "components/orders/modals/OrderPaymentModal";
import SendPaymentLinkModal from 'components/orders/modals/SendPaymentLinkModal';
import InvoiceBillingInfoModal from "components/orders/modals/InvoiceBillingInfoModal";
import './cart-buttons.css';
import { loadCart } from '../../redux/cartSlice';

function CartButton({ className = "" }) {
  const cart = useSelector((state) => state.cart);
  const [allowProfileInfoUpdate, setAllowProfileInfoUpdate] = useState(false);
  const navigate = useNavigate();
  const checkout = useCheckout({
    items: cart.items,

  });
  useEffect(() => {

    setAllowProfileInfoUpdate(checkout.afterBillingInfos === 'payment');
  }, [checkout.afterBillingInfos]);

  if (cart.items.length <= 0) {
    return null;
  }

  return (
    <div className={className}>

      <div className="cart-buttons">

        <div className="pb-5 row text-center">
          <div className="col-12 col-md-6 text-md-end">
            <button
              className="btn btn-sm  btn-danger rounded-pill"
              onClick={checkout.startCheckout}
            >
              Régler mes formalités
            </button>
          </div>
          <div className="col-12 col-md-6 text-md-start">
            <button
              onClick={checkout.startPaymentLink}
              className="btn btn-sm btn-outline-danger rounded-pill"
            >
              Envoyer un lien de paiement
            </button>
          </div>
        </div>
      </div>

      {checkout.showBillingModal && (
        <InvoiceBillingInfoModal
          show={true}
          defaultValues={checkout.billingInfos}
          onClose={checkout.closeBilling}
          onSave={checkout.handleBillingSave}
          enableProfileInfo={allowProfileInfoUpdate}
        />
      )}

      {checkout.showPaymentModal && (
        <OrderPaymentModal
          orderId={checkout.orderId}
          onClose={checkout.closePayment}
          onPaid={() => { navigate('/customer/account/orders') }}
        />
      )}
      {(checkout.showPaymentLinkModal) && (
        <SendPaymentLinkModal
          show={true}
          orderId={checkout.orderId}
          onClose={() => checkout.closePaymentLink}
          onSuccess={() => {
            checkout.closePaymentLink();
            navigate('/customer/account/orders');
            // load();
          }}
        />
      )}
    </div>
  );
} export default CartButton;


